import React, { useState } from 'react'
import { Box } from '@mui/material'
import ParentGym from './ParentGym'
import BranchGym from './BranchGym'
const ManageGyms = () => {
  const [activeTab, setActiveTab] = useState<number>(0)
  const tabs = ['Parent Gyms', 'Branch Gyms']

  if (activeTab === 0) return <ParentGym setActiveTab={setActiveTab} activeTab={activeTab}  tabs={tabs}/>
  if (activeTab === 1) return <BranchGym setActiveTab={setActiveTab} activeTab={activeTab}  tabs={tabs}/>
  return null
}

export default ManageGyms
